module.exports = __webpack_public_path__ + "img/menu-daily-check.6f7d7ab0.svg";